import DetailSuratJalan from "./DetailSuratJalan";

export default DetailSuratJalan;
